import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';
import { ErrorCard } from '../../components/Cards';

const ErrorView = (props: { error: any }) => (
  <Fade>
    <Container fluid className="mt-3">
      <Row>
        <Col>
          <ErrorCard error={props.error}></ErrorCard>
        </Col>
      </Row>
    </Container>
  </Fade>
);
export default ErrorView;
